import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const loginReducer = (state = InitialState.loginReducer, action) => {
    switch (action.type) {
        case ActionType.LOGIN_RESPONSE || ActionType.LOGOUT_RESPONSE: {
            return {
                ...state,
                loginObject: _.assign(action.loginObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default loginReducer;